import * as React from 'react';
import { cn } from '@/lib/utils';

const ModalScheduleImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('c-modal-schedule-img', 'block h-44 w-full rounded-lg object-cover', className)}
    {...props}
  />
));
ModalScheduleImg.displayName = 'ModalScheduleImg';

const ModalScheduleTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-modal-schedule-title', 'mb-0 text-base font-bold leading-6 text-primary-dark', className)}
    {...props}
  />
));
ModalScheduleTitle.displayName = 'ModalScheduleTitle';

const ModalScheduleDate = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-modal-schedule-date', 'mb-0 text-base font-bold text-neutral-dark', className)}
    {...props}
  />
));
ModalScheduleDate.displayName = 'ModalScheduleDate';

const ModalScheduleHour = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-modal-schedule-hour', 'mb-0 text-sm font-light text-neutral-dark', className)}
    {...props}
  />
));
ModalScheduleHour.displayName = 'ModalScheduleHour';

const ModalScheduleText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-modal-schedule-text', 'my-5 whitespace-pre-line text-sm font-light text-neutral-dark', className)}
    {...props}
  />
));
ModalScheduleText.displayName = 'ModalScheduleText';

export { ModalScheduleImg, ModalScheduleTitle, ModalScheduleDate, ModalScheduleHour, ModalScheduleText };
